const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || 'https://ab.pizzahub.lk/api').replace(/\/+$/, '');
export const OTP_API_URL = process.env.REACT_APP_OTP_API_URL || 'https://pizzahub.lk/otp_delete.php';

export const apiUrl = (path = '') => {
  const cleanPath = String(path || '').replace(/^\/+/, '');
  return cleanPath ? `${API_BASE_URL}/${cleanPath}` : API_BASE_URL;
};

export default API_BASE_URL;
